import React from 'react';
import { Typography } from '@material-ui/core';

function Conversions() {
  return (
    <div>
      <Typography variant="h5">
        Conversions page is coming soon.
      </Typography>
    </div>
  );
}

export default Conversions;
